import React from 'react';
import DeuConsumptionComponent from './DeuConsumption';

const DeuConsumption: React.FC = () => {
  return <DeuConsumptionComponent />;
};

export default DeuConsumption;